<template>
  <div class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <div id="userNotFound-wrapper" class="card">
            <div class="title">User not found</div>
            <div class="form-wrapper">
              <div class="form-input">
                <div class="subtitle">The requested user could not be found.</div>
                <div class="explanation">After the first scan with printers is sent from the maprint agent, you can try to reload the page.</div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-link btn-space btn-link-primary full" @click="reload" :disabled="loading">
            <span v-if="!loading">{{ t ? t('Reload') : 'Reload' }}</span>
            <span v-else>
              <i class="fad fa-circle-notch fa-spin"></i>
              Loading...
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
export default {
  data () {
    return {
      loading: false,
      unsubscribe: null
    }
  },
  mounted () {
    const $modal = $(this.$el)

    // Listen for when the modal is shown
    $modal.on('shown.bs.modal', () => {
      console.log('[UserNotFound] Modal shown, setting up listener')
      this.startListening()
    })

    // Listen for when the modal is hidden
    $modal.on('hidden.bs.modal', () => {
      console.log('[UserNotFound] Modal hidden, stopping listener')
      this.stopListening()
    })
  },
  beforeDestroy () {
    // Clean up the listener when component is destroyed
    this.stopListening()

    // Remove modal event listeners
    const $modal = $(this.$el)
    $modal.off('shown.bs.modal')
    $modal.off('hidden.bs.modal')
  },
  methods: {
    startListening () {
      // Don't start if already listening
      if (this.unsubscribe) return

      const userId = this.$store.state.userId
      if (userId) {
        console.log('[UserNotFound] Setting up listener for user:', userId)
        const userRef = this.$store.state.db.collection('users').doc(userId)

        // Set up a real-time listener for the user document
        this.unsubscribe = userRef.onSnapshot(snapshot => {
          if (snapshot.exists) {
            console.log('[UserNotFound] User document found, reloading...')
            this.loading = true
            window.location.reload()
          } else {
            console.log('[UserNotFound] User document still does not exist')
          }
        }, error => {
          console.error('[UserNotFound] Error listening to user document:', error)
        })
      }
    },
    stopListening () {
      if (this.unsubscribe) {
        console.log('[UserNotFound] Cleaning up listener')
        this.unsubscribe()
        this.unsubscribe = null
      }
    },
    reload () {
      console.log('[UserNotFound] reload clicked')
      this.loading = true
      try { window.location.reload() } finally { this.loading = false }
    }
  }
}
</script>

<style lang="scss">
#app {
  #user-not-found {
    #userNotFound-wrapper {
      margin: 0 auto;
      color: black;
      font-family: monospace;
      width: 100%;
      .title {
        font-weight: bold;
      }
      .subtitle {
        font-size: 1.25rem;
      }
        .explanation {
          font-size: 0.95rem;
          color: #666;
          margin-top: 0.5rem;
          line-height: 1.35rem;
        }
    }
    .modal-content {
      max-width: 32rem;
      margin: 0 auto;
      padding: 1.5rem;
      margin-top: 14vh;
      .modal-body {
        padding-top: unset;
        padding: 0;
        font-size: 1.4rem;
        .form-wrapper {
          padding: 1rem 0;
        }
      }
      .modal-footer {
        justify-content: unset;
        padding: 0;
        .btn-link {
          margin: 0 auto;
          border: 1px solid;
          font-size: 14px;
          font-weight: bold;
          text-transform: capitalize;
          width: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserNotFound.vue